import { render, staticRenderFns } from "./EditTaxAssessmentModal.vue?vue&type=template&id=523f6302&"
import script from "./EditTaxAssessmentModal.vue?vue&type=script&lang=ts&"
export * from "./EditTaxAssessmentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports